/*
  About — media band video controls (Pause Rituals)
  - Default: autoplay + muted + loop; custom Mute/Unmute + Play/Pause buttons.
  - "click" mode: poster + center play button → plays with sound.
  - Swaps to a mobile video/poster when provided; otherwise the main video is cropped.
  - Respects prefers-reduced-motion (no autoplay) and pauses when scrolled out of view.
  Idempotent; re-inits on Shopify section load.
*/
(function () {
  var MOBILE = '(max-width: 749px)';

  function setup(root) {
    if (root.dataset.amediaReady === '1') return;
    root.dataset.amediaReady = '1';

    var video = root.querySelector('[data-amedia-video]');
    if (!video) return; // image-only section

    var playback = video.getAttribute('data-playback') || 'autoplay';
    var ppBtn = root.querySelector('[data-amedia-playpause]');
    var muteBtn = root.querySelector('[data-amedia-mute]');
    var overlay = root.querySelector('[data-amedia-overlay]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ---- responsive sources / poster (Shopify's auto preview_image → no black flash) ----
    var desktopHTML = video.innerHTML;
    var posterD = video.getAttribute('data-poster-d') || '';
    var posterM = video.getAttribute('data-poster-m') || '';
    var mobileRaw = video.getAttribute('data-mobile-srcs') || '';
    var mobileHTML = mobileRaw
      ? mobileRaw.split('~~').map(function (p) {
          var b = p.split('::');
          return b[0] ? '<source src="' + b[0] + '" type="' + (b[1] || '') + '">' : '';
        }).join('')
      : '';
    var currentBP = 'desktop';

    function safePlay() {
      var pr = video.play();
      if (pr && pr.catch) pr.catch(function () {});
    }
    function setMuted(on) {
      video.muted = on;
      root.classList.toggle('is-muted', on);
    }

    function applyBP() {
      var isM = window.matchMedia(MOBILE).matches;
      var p = isM && posterM ? posterM : posterD;
      if (p) video.setAttribute('poster', p);
      var want = isM && mobileHTML ? 'mobile' : 'desktop';
      if (want === currentBP) return;
      currentBP = want;
      var wasPlaying = !video.paused;
      video.innerHTML = want === 'mobile' ? mobileHTML : desktopHTML;
      video.load();
      if (wasPlaying || (playback === 'autoplay' && !reduce)) safePlay();
    }

    // Show the video's own FIRST FRAME as the still (no poster image). Nudging
    // currentTime forces browsers to paint the frame instead of staying blank.
    video.addEventListener('loadedmetadata', function () {
      if (video.paused && video.currentTime < 0.01) {
        try { video.currentTime = 0.05; } catch (e) {}
      }
    });

    // ---- controls ----
    function togglePlay() {
      if (video.paused) safePlay();
      else video.pause();
    }
    if (ppBtn) ppBtn.addEventListener('click', togglePlay);
    if (muteBtn) muteBtn.addEventListener('click', function () { setMuted(!video.muted); });
    if (overlay) overlay.addEventListener('click', function () { setMuted(false); root.classList.add('is-buffering'); safePlay(); });
    video.addEventListener('click', togglePlay);

    // Buffer ahead so the first click plays instantly (without blocking page load):
    // warm up on hover/touch intent + shortly after the page finishes loading.
    function warm() {
      if (video.paused && video.getAttribute('preload') !== 'auto') {
        video.setAttribute('preload', 'auto');
        try { video.load(); } catch (e) {}
      }
    }
    ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) {
      root.addEventListener(ev, warm, { passive: true });
    });
    if (document.readyState === 'complete') setTimeout(warm, 1500);
    else window.addEventListener('load', function () { setTimeout(warm, 1500); });

    // loading feedback while buffering
    video.addEventListener('waiting', function () { root.classList.add('is-buffering'); });
    video.addEventListener('canplay', function () { root.classList.remove('is-buffering'); });

    video.addEventListener('play', function () { root.classList.add('is-playing'); });
    video.addEventListener('pause', function () { root.classList.remove('is-playing'); });
    video.addEventListener('volumechange', function () { root.classList.toggle('is-muted', video.muted); });

    // auto-hide controls while playing
    var idle;
    function poke() {
      root.classList.remove('controls-idle');
      clearTimeout(idle);
      idle = setTimeout(function () { if (!video.paused) root.classList.add('controls-idle'); }, 2600);
    }
    root.addEventListener('mousemove', poke);
    root.addEventListener('touchstart', poke, { passive: true });

    // ---- init ----
    applyBP();
    var mq = window.matchMedia(MOBILE);
    if (mq.addEventListener) mq.addEventListener('change', applyBP);
    else if (mq.addListener) mq.addListener(applyBP);

    if (playback === 'autoplay' && !reduce) {
      setMuted(true);
      safePlay();
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) safePlay();
            else video.pause();
          });
        }, { threshold: 0.15 }).observe(root);
      }
    } else {
      setMuted(true); // unmuted on first user play (via overlay/mute button)
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('.amedia').forEach(setup);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
